
const knisaMainRU = {
  "knisa_main_title": "Входные документы",
  "knisa_main_search_placeholder": "Поиск документа",
  "knisa_main_button_new": "Добавить поступление",
}

const knisaCreatePageRU = {
  "knisa_create_page_title": "Новое поступление",
  "knisa_create_page_title_ids": "Поступление: {{id}}",
  "knisa_create_page_search_placeholder": "Поиск",
  "knisa_create_page_back": "Назад",
  "knisa_create_page_addItem": "Добавить товар",
  "knisa_create_page_editTitle_aria": "Редактировать заголовок поступления",
  "knisa_create_divide_modal_title": "Разделение поступления {{entry}}-{{detail}}",
  "knisa_create_pallets_modal_title": "Паллеты — поступление {{entry}}-{{detail}}",
}

const knisaCreateTitleModalRU = {
  "knisa_create_modal_title_title": "Новое поступление",
  "knisa_create_modal_title_date": "Дата",
  "knisa_create_modal_title_time": "Время",
  "knisa_create_modal_title_grower": "Поставщик",
  "knisa_create_modal_title_refference": "Ссылка",
  "knisa_create_modal_title_carNum": "Номер машины",
  "knisa_create_modal_title_carSelect": "Выбор машины",
  "knisa_create_modal_title_carClear": "Без машины",
  "knisa_create_modal_title_driver": "Водитель",
  "knisa_create_modal_title_warehouse": "Склад",
  "knisa_create_modal_title_teudaType": "Тип документа",
  "knisa_create_modal_title_remark": "Примечание",
  "knisa_create_modal_title_saveTitle": "Создать поступление",
  "knisa_create_modal_title_continue": "Продолжить",
  "knisa_create_modal_title_referenceExistsForDate": "Ссылка уже существует на дату {{date}}",
}

const knisaCreateProductModalRU = {
  "knisa_create_modal_product_title_create": "Добавить товар",
  "knisa_create_modal_product_title_edit": "Редактировать товар",
  "knisa_create_modal_product_externalEntry": "Внешний номер ",
  "knisa_create_modal_product_externalPalletExists": "Такой номер уже существует",
  "knisa_create_modal_product_pallet": "Паллет",
  "knisa_create_modal_product_qty": "Кол-во",
  "knisa_create_modal_product_product": "Товар",
  "knisa_create_modal_product_size": "Размер",
  "knisa_create_modal_product_package": "Упаковка",
  "knisa_create_modal_product_weight": "Вес",
  "knisa_create_modal_product_price": "Цена",
  "knisa_create_modal_product_detection": "Местоположение",
  "knisa_create_modal_product_expiryDate": "Срок годности",
  "knisa_create_modal_product_copy": "Копировать",
  "knisa_create_modal_product_multiplier": "Множитель",
  "knisa_create_modal_product_includeWeight": "Включая вес",
  "knisa_create_modal_product_createButton": "Добавить товар",
  "knisa_create_modal_product_createPallet": "Создать паллет",
  "knisa_create_modal_product_readScale_aria": "Считать вес с весов",
}

const knisaCreateElementRU = {
  "knisa_create_element_swipe_edit": "Редактировать",
  "knisa_create_element_swipe_delete": "Удалить",
  "knisa_create_element_swipe_divide": "Разделить",
  "knisa_create_element_netto": "Нетто",
  "knisa_create_element_brutto": "Брутто",
  "knisa_create_element_print_aria": "Печать",
}

const knisaNotificationsRU = {
  "knisa_notification_printPalletSuccess": "Паллет {{num}} успешно напечатан",
  "knisa_notification_printEntrySuccess": "Поступление {{num}} успешно напечатано",
  "knisa_create_mass_print_title": "Печать наклеек",
  "knisa_create_mass_print_message": "Вы уверены, что хотите напечатать сразу все наклейки?",
  "knisa_create_mass_print_confirm": "Печать",
  "knisa_create_mass_print_printing": "Печать...",
  "knisa_notification_massPrintSuccess": "Все наклейки успешно напечатаны",
  "knisa_notification_growerHasNoProduct": "У данного поставщика нет выбранного товара",
  "knisa_notification_massPrintFailure": "Одна или несколько наклеек не напечатались — повторите",
  "knisa_notification_printEntryFailure": "Не удалось напечатать поступление {{num}}",
  "knisa_notification_genericError": "Что-то пошло не так",
  "knisa_notification_entryUpdated": "Поступление успешно обновлено",
  "knisa_notification_referenceExists": "Ссылка уже принята на дату {{date}}",
  "knisa_notification_cannotDeletePicked": "Нельзя удалить поступление, которое уже было отгружено",
  "knisa_notification_palletDeleted": "Паллет успешно удалён",
  "knisa_notification_entryDeleted": "Поступление успешно удалено",
  "knisa_notification_cannotDivide": "Невозможно разделить",
}

export const knisaTranslationRU = {
  knisa: {
    ...knisaMainRU,
    ...knisaCreatePageRU,
    ...knisaCreateTitleModalRU,
    ...knisaCreateProductModalRU,
    ...knisaCreateElementRU,
    ...knisaNotificationsRU
  }
}